import App from '@/models/App'
import ChatMember from '@/models/ChatMember'
import ChatMessage from '@/models/ChatMessage'

export default class ChatRoom extends App {
    static get entity() {
        return 'ChatRooms'
    }
    static fields() {
        return {
            id: this.attr(''),
            name: this.attr(''),
            companyName: this.attr(''),
            image: this.attr(''),
            chatMemberId: this.attr(''),
            isPersonal: this.attr(''),
            isDeleted: this.attr(''),
            isApproval: this.attr(''),
            isApprovalMember: this.attr(''),
            members: this.hasMany(ChatMember, 'chatRoomId', 'id'),
            unreadMessagesCount: this.attr(''),
            email: this.attr(''),
            tel: this.attr(''),
            // messages: this.hasMany(ChatMessage, 'chatRoomId', 'id'),
            inputMessage: this.attr(''),
            isSentMessage: this.attr(false),
            messageCurrentPage: this.attr(''),
            messageLastPage: this.attr(''),
            messageViewPoint: this.attr(''),
        }
    }
    static find(chatRoomId) {
        return this.query().withAllRecursive().find(chatRoomId)
    }
    static get() {
        return this.query()
            .withAllRecursive()
            .get()
            .filter((chatRoom) => {
                if (!chatRoom.isDeleted) {
                    return chatRoom
                }
            })
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static updateApproval(chatRoomId, isApproval) {
        this.update({
            where: chatRoomId,
            data: {
                isApproval: isApproval,
            },
        })
    }
    static apiConfig = {
        actions: {
            find(chatRoomId) {
                return this.get(`/chats/rooms/${chatRoomId}`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.overallURL(),
                })
            },
            fetch() {
                return this.get(`/chats/rooms`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.overallURL(),
                })
            },
            create(params) {
                return this.post(`/chats/rooms`, App.post(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.overallURL(),
                })
            },
            destroy(chatRoomId) {
                return this.delete(`/chats/rooms/${chatRoomId}`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    delete: 'data',
                    baseURL: App.overallURL(),
                })
            },
            update(chatRoomId, params) {
                return this.patch(
                    `/chats/rooms/${chatRoomId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: 'data',
                        baseURL: App.overallURL(),
                    }
                )
            },
        },
    }
}
